@if (showHeading) {
  <h3
    [id]="field?.id"
    class="agpr-staticTextHeadingField"
    [class.agpr-staticTextHeadingField--withAction]="field?.action"
  >
    <span>{{ field?.heading | localize }}</span>
    @if (field?.action) {
      <agpr-button
        [icon]="field.action.icon"
        [style]="buttonTypes.icon"
        [tooltip]="field.action.tooltip"
        tooltipPosition="top"
        (click)="openActionPanel()"
      ></agpr-button>
    }
  </h3>
}
